import * as React from 'react';
import {useMediaQuery, useTheme} from '@mui/material';
import JobPositions from './jobs/JobPositions';
import {useAuth} from '../../context/AuthContext';
import {hasRole} from '../../utils/jwtHelper';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export default function JobTabs(): React.ReactElement {

    const [value, setValue] = React.useState(0);
    const {token} = useAuth();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Check if user has adm_payroll role (not adm_branch_payroll)
    const canViewPayrollPeriods = hasRole(token, 'adm_payroll');

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            {canViewPayrollPeriods && (
                <JobPositions/>
            )}

        </>
    );

};